export default "__VITE_ASSET__Cjw9nufF__"